import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-salfa-info-tag',
  templateUrl: './salfa-info-tag.component.html',
  styleUrls: ['./salfa-info-tag.component.scss']
})
export class SalfaInfoTagComponent {
    reporte: any
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {
        this.reporte = data.reporte;
    }
}
